module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/financial-47713766badc1bd4d279a8a2279a2741.svg";